import React, { useEffect } from 'react'
import Header2 from '../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import AboutMain from '../components/about/AboutMain'
import WeAreZM from '../components/about/WeAreZM'
import CoreValues from '../components/about/CoreValues'
import WhatWeStandFor from '../components/about/WhatWeStandFor'
import OurVision from '../components/about/OurVision'
import { useLanguage } from '../contexts/LanguageContext'

const AboutPage = () => {
    const { t } = useLanguage();
    
    useEffect(() => {
        window.scrollTo(0,0);
    },[])
    
    return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>{t('seo.aboutTitle')}</title>
        <meta name="description" content={t('seo.aboutDescription')} />
    </Helmet>
    </HelmetProvider>
    <div style={{ overflow:'hidden', backgroundImage:'url("bg-img/MicrosoftTeams-image.webp")', width:'100%', position:'', backgroundAttachment:'fixed'}}>
    <Header2/>
        <AboutMain/>
        <WeAreZM/>
        <CoreValues/>
        <WhatWeStandFor/>
        <OurVision/>
    </div>
    </>
  )
}

export default AboutPage